import(/* webpackMode: "eager" */ "/app/landing/src/app/agb/page.tsx");
